import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { categories, categoryColors } from '@/mocks/categories';

export default function CategorySection() {
  const { t } = useTranslation('home');

  return (
    <section id="categories-section" className="w-full py-14 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900 mb-3">
            {t('category_title')}
          </h2>
          <p className="text-foreground-600 text-sm md:text-base max-w-xl mx-auto">
            {t('category_subtitle')}
          </p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-6 gap-4 md:gap-5">
          {categories.map((cat, index) => {
            const colors = categoryColors[cat.color];
            return (
              <Link
                key={cat.slug}
                to={`/category/${cat.slug}`}
                className={`group relative flex flex-col items-center text-center p-5 md:p-6 rounded-xl transition-all duration-300 hover:scale-105 cursor-pointer ${colors.bg} bg-opacity-60 hover:bg-opacity-100`}
                style={{ animationDelay: `${index * 0.08}s` }}
              >
                <div className="w-12 h-12 md:w-14 md:h-14 flex items-center justify-center rounded-full bg-background-50 mb-3 transition-all duration-300 group-hover:shadow-md">
                  <i className={`${cat.icon} text-xl md:text-2xl ${colors.text}`}></i>
                </div>
                <span className="font-heading font-semibold text-sm md:text-base text-foreground-800 mb-1 whitespace-nowrap">
                  {cat.name}
                </span>
                <span className="text-xs text-foreground-500 leading-tight hidden sm:block">
                  {cat.description.slice(0, 20)}...
                </span>
              </Link>
            );
          })}
        </div>
      </div>
    </section>
  );
}